import { connect } from 'react-redux';
import SummaryList from 'components/general/SummaryList/SummaryList';
import alertsIndexFetch from './../thunk';
import { selectors } from '../ducks/list.duck';

const mapStateToProps = state => ({
  loading: selectors.loading(state),
  pagination: selectors.pagination(state),
  items: selectors.items(state),
});

const mapDispatchToProps = dispatch => ({
  retry: () => dispatch(alertsIndexFetch),
});

const AlertsList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SummaryList);

export default AlertsList;
